<div class="pad"  >

  <div  fxLayout="row" fxLayoutGap="10px" ffxLayoutAlign="start center">

    <div   *ngFor="let item of items; let i = index;" fxLayout="row" fxLayoutAlign="start center">

      <mat-icon  *ngIf="i!=0" class="chevron">chevron_right</mat-icon>
      <a class="tye"  [hidden]="i == (items.length - 1)">{{item.name}}</a>

      <span class="tye"   [hidden]="i != (items.length - 1)" class="breadcrumb-title active"><b>{{item.name}}</b></span>
    </div>

  </div>
</div>
